export function getBaseLocation() {
  if (location.pathname.includes('admin')) {
    return '/admin';
  }
  return '/';
}


export function base64EncodeUtf8(str: string): string {
  return btoa(
    new TextEncoder().encode(str)
      .reduce((acc, byte) => acc + String.fromCharCode(byte), '')
  );
}